import Box from '@o2/ui/Box';
import { FC, ReactNode } from 'react';

const Content: FC<{ children: ReactNode }> = ({ children, ...props }) => {
  return (
    <Box maxHeight="100%" flex={1} overflow="auto" px={2.5} py={4} {...props}>
      {children}
    </Box>
  );
};

export default Content;
